<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.TransactionCode }}</td>
                <td class="text-end">{{ item.Weight | currency('', 1)}}</td>
                <td class="text-end">{{ item.Length ? item.Length + ' x ' + item.Width + ' x ' + item.Height : '' }}</td>
                <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
                <td class="text-end">
                  <div>{{ item.FeeShipVND | currency('₫', 0)}}</div>
                  <div class="text-red">{{ item.FeeShip | currency('¥', 1)}}</div>
                </td>
                <td class="text-end">{{ item.FeeOther | currency('') }}</td>
                <td v-bind:style="{ 'color': text_color(item.ShippingMethod, shipping_methods)}">{{ item.ShippingMethod | display_value(shipping_methods) }}</td>
                <td v-bind:style="{ 'color': text_color(item.ProductType, product_types)}">{{ item.ProductType | display_value(product_types) }}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td v-bind:style="{ 'color': text_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                <td v-if="userRole > 0">{{ item.Owners && item.Owners != '' ? 'Có khách nhận' : '' }}</td>
                <td v-else>
                  <v-edit-dialog :return-value.sync="item.Checked" large lazy persistent @save="checkItem({ID: item.ID, Checked: item.Checked})">
                    <div>{{ item.Checked ? 'Chờ duyệt' : '' }}</div>
                    <template v-slot:input>
                      <v-switch v-model="item.Checked" color="#9152f8" label="Nhận hàng"></v-switch>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-center" v-if="userRole > 0">
                  <v-icon medium @click="gotoDetail(item)" class="pa-2">edit</v-icon>
                  <v-icon medium @click="deleteItem(item.ID)" class="pa-2">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <store-popup
        :dialogStoreManager="dialogStoreManager"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></store-popup>
      <v-dialog v-model="dialogEditTranCode" persistent max-width="700px">
        <v-card>
          <v-card-title>
            <span class="title">Cập nhật kiện #{{currentItem.TransactionCode}}</span>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0>
                <v-radio-group v-model="radioGroup">
                  <v-radio v-for="(customer, index) in currentItem.Customers" :key="index" color="#9152f8" :label="`${customer.FullName} (${customer.PhoneNumber})`" :value="index"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogEditTranCode = false">Đóng</v-btn>
            <v-btn color="blue darken-1" text @click="saveData">Lưu lại</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
// import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    "store-popup": store
  },
  data() {
    return {
      radioGroup: -1,
      shipping_methods: configs.SHIPPING_METHOD,
      product_types: configs.PRODUCT_TYPE,
      package_status: configs.PACKAGE_STATUS,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false,
      dialogImport: false,
      dataImport: '',
      importStep: 0,
      importUID: 0,
      appLoading: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.storeManager.all.data,
      total_rows: state => state.storeManager.all.total,
      currentItem: state => state.storeManager.selected,
      loading: state => state.storeManager.loading,
      customers: state => state.customer.all.data
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      let tmp_headers = [
        {
          text: "Mã kiện",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Kích thước",
          value: "Volume",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số khối",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship nội địa",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí phát sinh",
          value: "FeeOther",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Hình thức vận chuyển",
          value: "ShippingMethod",
          filterable: true,
          values: configs.SHIPPING_METHOD,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Loại hàng",
          value: "ProductType",
          filterable: true,
          values: configs.PRODUCT_TYPE,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Tình trạng",
          value: "Owners",
          filterable: false,
          dataType: configs.DATA_TYPE["String"]
        }
      ];
      if(this.userRole > 0) {
        tmp_headers.push({
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        });
      }
      return tmp_headers;
    }
  },
  methods: {
    filter_data: function() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {});
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("storeManager/getListNoneOwner", param);
      this.getCustomerList();
      this.appLoading = false;
    },
    gotoDetail: function(item) {
      this.$store.commit("storeManager/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$store.commit("storeManager/setDetail", {
        data: {
          ID: 0,
          TransactionCode: "",
          FeeShip: 0
        }
      });
      this.dialogStoreManager = true;
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Email"]
      });
    },
    checkItem(item) {
      this.$store.dispatch("storeManager/checkPackage", {
          'data': {checked: item.Checked},
          'id': item.ID
        });
    },
    saveData() {
      if(this.radioGroup >= 0) {
        let selectCustomer = this.currentItem.Customers[this.radioGroup];
        this.$store.dispatch("storeManager/setDetail", {
          'data': {UID: selectCustomer.ID},
          'id': this.currentItem.ID
        });
      }
      this.dialogEditTranCode = false;
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    },
    text_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("storeManager/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
